// Issue #72: useCopilotReadable / useCopilotAction の呼び出しを隔離するコンポーネント。
// <CopilotKit> 配下でのみ描画すること（プロバイダ外で描画すると例外になる）。
import { useBusinessSheetCopilotActions } from "../../hooks/useBusinessSheetCopilotActions";

const CopilotActions = ({ businessSheetData, updateBusinessSheetData }) => {
  useBusinessSheetCopilotActions({
    businessSheetData,
    updateBusinessSheetData,
  });

  return null;
};

export default CopilotActions;
